import { MOCK } from "utils/constants";
import * as ec from "./ec";
import * as ecMock from "./ec.mock";

export const postSignTerm = MOCK ? ecMock.postSignTerm : ec.postSignTerm;

export const postEcLogin = MOCK ? ecMock.postEcLogin : ec.postEcLogin;

export const getOcorrenciaCRM = MOCK
  ? ecMock.getOcorrenciaCRM
  : ec.getOcorrenciaCRM;

export const downloadDocumentNew = MOCK
  ? ecMock.downloadDocumentNew
  : ec.downloadDocumentNew;
